import { Modal } from 'components/modal/Modal';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ExecuteToggle } from 'state/ducks/Modals';
import { BeautyProfile } from 'components/person/BeautyProfile';
import { CreateWithVoucher } from 'components/voucher/CreateWithVoucher';
import { MeuCupom } from 'components/person/MeuCupom';

class Modals extends Component {
  // constructor(props) {
  //   super(props);
  // }

  toggle = (name) => {
    return () => {
      this.props.toggle(name);
    };
  };

  renderCreateWithVoucherModal = () => {
    const { modals, partnerInfo, token, person } = this.props;
    return (
      <Modal
        visible={true === modals['createWithVoucher']}
        onCloseModal={this.toggle('createWithVoucher')}
        useDefaultDialog={false}
        disableBackdropClose={true}
      >
        <div className={'voucher-modal'}>
          <CreateWithVoucher
            authorization={token.Authorization}
            personId={token.personId}
            person={person}
            onExecutionFinish={this.toggle('createWithVoucher')}
            voucherNumber={partnerInfo.number}
          />
        </div>
      </Modal>
    );
  };

  render() {
    const { modals, partnerInfo } = this.props;
    return (
      <>
        <Modal
          visible={true === modals['beautyProfile']}
          onCloseModal={this.toggle('beautyProfile')}
          useDefaultDialog={false}
          className={'modal__wrap-beautyprofile'}
        >
          <BeautyProfile skipFirstStep={false} onFinish={this.toggle('beautyProfile')} />
        </Modal>

        {partnerInfo && this.renderCreateWithVoucherModal()}

        <Modal
          visible={true === modals['coupon']}
          onCloseModal={this.toggle('coupon')}
          useDefaultDialog={true}
          disableBackdropClose={true}
        >
          <MeuCupom onFinish={this.toggle('coupon')} />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
  modals: state.modals,
  partnerInfo: state.partnerInfo.data,
  token: state.token.data,
});

const mapDispatch = (dispatch) => ({
  toggle: (name) => {
    dispatch(ExecuteToggle(name));
  },
});

Modals = connect(mapStateToProps, mapDispatch)(Modals);

export { Modals };
